import { createBrowserRouter, Navigate } from "react-router-dom";

import { LoginRedirect } from "./auth";
import { AppLayout } from "./layouts/AppLayout";
import { AgentsRoute } from "./routes/AgentsRoute";
import { BulkImportRoute } from "./routes/BulkImportRoute";
import { NewProjectRoute } from "./routes/NewProjectRoute";
import { OperationsRoute } from "./routes/OperationsRoute";
import { ProjectDetailsRoute } from "./routes/ProjectDetailsRoute";
import { RunDetailRoute } from "./routes/RunDetailRoute";

// Mirrors admin-app's createBrowserRouter pattern. One layout
// (AppLayout) renders the sidebar + topbar + outlet; routes render
// inside the outlet.
//
// Ported so far:
//   - /operations - Operations dashboard
//   - /agents     - Agent roster (Architecture)
//   - /runs/:projectId/:runId - Run detail (with interactive
//     resolutions for the Phase 1 action-items loop)
//   - /new        - New project intake + upload + submit
//   - /bulk       - Bulk import from Excel/CSV tracker
//   - /projects/:projectId - Full Project metadata editor
//     (every tracker column + status notes)
//
// See inrange_agents_frontend_incremental_rebuild.md for the
// chip-away strategy.
export const router = createBrowserRouter([
  // Kinde post-login redirect target. Sits at the top level (no
  // AppLayout) so the redirect lands cleanly before the layout +
  // its API hooks fire.
  { path: "/login-redirect", element: <LoginRedirect /> },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <Navigate to="/operations" replace /> },
      { path: "operations", element: <OperationsRoute /> },
      { path: "agents", element: <AgentsRoute /> },
      {
        path: "runs/:projectId/:runId",
        element: <RunDetailRoute />,
      },
      { path: "new", element: <NewProjectRoute /> },
      { path: "bulk", element: <BulkImportRoute /> },
      {
        path: "projects/:projectId",
        element: <ProjectDetailsRoute />,
      },
      {
        path: "*",
        element: <Navigate to="/operations" replace />,
      },
    ],
  },
]);
